import React from 'react';
import '../styles/Testimonials.css';

import T3 from '../assets/T3.jpg';
import T4 from '../assets/T4.jpg';
import T5 from '../assets/T5.jpg';
import T6 from '../assets/T6.jpg';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Samuel Tekle',
      position: 'Operations Manager',
      company: 'Ethio Manufacturing PLC',
      testimonial: '“Dani Import and Export Trading ensured our supply chain was flawless, delivering exceptional results every time. Their attention to detail and reliability transformed our import process.”',
      image: T3,
      rating: 5
    },
    {
      id: 2,
      name: 'Meron Getachew',
      position: 'Procurement Director',
      company: 'Addis Industrial Solutions',
      testimonial: '“The team\'s expertise in customs clearance and logistics saved us countless hours and resources. Truly professional service from start to finish.”',
      image: T4,
      rating: 5
    },
    {
      id: 3,
      name: 'Hawi Tadesse',
      position: 'Business Owner',
      company: 'Global Textiles Ethiopia',
      testimonial: '“Working with Dani Trading opened new markets for us. Their China sourcing network is unparalleled in quality and reliability.”',
      image: T5,
      rating: 5
    },
    {
      id: 4,
      name: 'Yonas Asrat',
      position: 'Supply Chain Coordinator',
      company: 'East Africa Trading Group',
      testimonial: '“Exceptional end-to-end service! From sourcing to delivery, every step was handled professionally. Our go-to partner for international trade.”',
      image: T6,
      rating: 5
    },
    {
      id: 5,
      name: 'Bereket Haile',
      position: 'Import Specialist',
      company: 'National Construction Ltd',
      testimonial: '“Their machinery import support was outstanding. Complex equipment arrived on time and in perfect condition. Highly recommended!”',
      image: T3,
      rating: 5
    },
    {
      id: 6,
      name: 'Sofia Mohammed',
      position: 'International Trade Manager',
      company: 'Horn of Africa Exporters',
      testimonial: '“The partnership development services helped us establish crucial connections in China. Their network is truly valuable for Ethiopian businesses.”',
      image: T4,
      rating: 5
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className={`star ${index < rating ? 'filled' : ''}`}>
        ★
      </span>
    ));
  };

  return (
    <div className="page testimonials-page">
      <header className="testimonials-header">
        <h1>Bridging Borders with Trusted Trade Solutions</h1>
        <p>Hear from our valued partners about their seamless trade experiences and dependable service.</p>
      </header>

      <section className="testimonials-grid">
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="testimonial-card">
            <div className="quote-icon">"</div>
            
            <div className="testimonial-content">
              <p className="testimonial-text">{testimonial.testimonial}</p>
              
              <div className="rating">
                {renderStars(testimonial.rating)}
              </div>
            </div>

            <div className="client-info">
              <div className="client-image-container">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="client-image"
                />
              </div>
              
              <div className="client-details">
                <h3 className="client-name">{testimonial.name}</h3>
                <p className="client-position">{testimonial.position}</p>
                <p className="client-company">{testimonial.company}</p>
              </div>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Testimonials;